import axios from "@/utils/axios";
export const loadBalance = async (store, studentEducation) => {
    store.commit("SET_BALANCE_LOADING", true);
    store.commit("SET_BALANCE_SUCCESS", null);
    const request = axios
        .get(`/balance/student-education/${studentEducation.id}`)
        .then((response) => {
        store.commit("SET_BALANCE_ITEM", response.data.saldo);
        store.commit("SET_BALANCE_LOADING", false);
        store.commit("SET_BALANCE_SUCCESS", true);
    })
        .catch((error) => {
        store.commit("SET_ERROR", error);
        store.commit("SET_BALANCE_LOADING", false);
        store.commit("SET_BALANCE_SUCCESS", false);
    });
    return request;
};
export const setError = async (store, error) => {
    store.commit("SET_ERROR", error);
};
export const setBalanceSuccess = async (store, success) => {
    store.commit("SET_BALANCE_SUCCESS", success);
};
export const setBalanceLoading = async (store, loading) => {
    store.commit("SET_BALANCE_LOADING", loading);
};
export const setBalanceItem = async (store, balanceItem) => {
    store.commit("SET_BALANCE_ITEM", balanceItem);
};
export const setSelectedEducation = async (store, selectedEducation) => {
    store.commit("SET_SELECTED_EDUCATION", selectedEducation);
};
export const reset = async (store) => {
    store.commit("SET_SELECTED_EDUCATION", null);
    store.commit("SET_ERROR", null);
    store.commit("SET_BALANCE_ITEM", null);
    store.commit("SET_BALANCE_LOADING", false);
    store.commit("SET_BALANCE_SUCCESS", null);
};
export default {
    setError,
    setBalanceSuccess,
    setBalanceLoading,
    setBalanceItem,
    setSelectedEducation,
    loadBalance,
    reset,
};
